import { Component, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
// Components
import { LeafletMapComponent } from 'src/app/components/leaflet-map/leaflet-map.component';
// Models
import { Region } from '@mocca-technologies/model';

@Component({
  selector: 'app-new-region-card',
  templateUrl: './new-region-card.component.html',
  styleUrls: ['./new-region-card.component.scss'],
})

export class NewRegionCardComponent implements OnInit {

  // Local variables
  region = {} as Region;
  leafletMapComponent: LeafletMapComponent;
  primaryColor: string;

  constructor(
    private alertController: AlertController,
    private translateService: TranslateService,
  ) { }

  ngOnInit() {
    const rootStyle = getComputedStyle(document.documentElement);
    this.primaryColor = rootStyle.getPropertyValue('--ion-color-primary').trim();
  }

  /**
   * Paints the region polygon on the shared map.
   */
  drawRegion(): void {
    this.leafletMapComponent.drawNewRegion(this.primaryColor)
      .then((layer: L.Polygon) => {
        this.region.polygonLayer = layer;
      })
      .catch(async (_error) => {
        const alert = await this.alertController.create({
          header: this.translateService.instant('REGION.ERROR_CREATING_POLYGON'),
          message: this.translateService.instant('REGION.ERROR_CREATING_POLYGON_MESSAGE'),
          buttons: [{ text: this.translateService.instant('COMMON.BUTTONS.OK'), role: 'cancel' }],
        });
        await alert.present();
      });
  }

  /**
   * Removes the drawn polygon and resets the region.
   */
  removeRegion(): void {
    this.leafletMapComponent.removeRegionArea(this.region.polygonLayer);
    this.region = {} as Region;
  }
}
